export default "__VITE_ASSET__uWOW0NGs__";